import GenericErrorPage from './GenericErrorPage.tsx'

export default function NetworkErrorPage() {
  return (
    <GenericErrorPage
      title="Oops! Something went wrong"
      description="We’re currently experiencing some technical difficulties. Please bear with us while we resolve the issue. Thank you for your understanding"
    />
  )
}
